export const SponsorOnboardingRoot = "/w/sponsor-onboarding";

export const SponsorOnboardingRoutes = {
  SWITCH_SPONSOR: SponsorOnboardingRoot + "/switch-sponsor/:id",
};
